import React from 'react';

export const LogoHeading:React.FC<{heading: string}> = ({heading}) => {
  return (
    <p className="text-primary text-[22px] leading-[26px] capitalize" style={{fontWeight: 600}}>
      {heading}
    </p>
  )
}
